// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"e2358d15","364":"71534ea7","418":"429c947e","661":"b0f9696c"}[chunkId] + ".js";
};